import { useState } from "react";
import { Button } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import PrintIcon from "@material-ui/icons/Print";
import { downloadFootHealthReport, printFootHealthReport } from "../../../../utils/report/footHealthReport";

type Action = "DOWNLOAD" | "PRINT" | null;

/**
 * Download / Print pair rendered in the action column of the scan grid.
 *
 * ag-grid hands the row document in through props.data, so each cell works off its own
 * scan rather than whichever cell happens to be focused.
 */
const ReportActionsCell = (props: any): JSX.Element => {
	const [pendingAction, setPendingAction] = useState<Action>(null);
	const scan = props.data;

	const runAction = async (action: Action) => {
		if (!scan || !scan._id || pendingAction) {
			return;
		}

		setPendingAction(action);
		try {
			if (action === "DOWNLOAD") {
				await downloadFootHealthReport(scan._id, `foot-health-report-${scan.customer_scan_id || scan._id}`);
			} else {
				await printFootHealthReport(scan._id);
			}
		} catch (error) {
			console.log("Foot health report action failed", error);
			alert("Could not generate the report. Please try again.");
		} finally {
			setPendingAction(null);
		}
	};

	return (
		<div className="report-actions-cell">
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				startIcon={<GetAppIcon />}
				disabled={pendingAction !== null}
				onClick={() => runAction("DOWNLOAD")}
			>
				{pendingAction === "DOWNLOAD" ? "Generating…" : "Download"}
			</Button>
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				startIcon={<PrintIcon />}
				disabled={pendingAction !== null}
				onClick={() => runAction("PRINT")}
			>
				{pendingAction === "PRINT" ? "Generating…" : "Print"}
			</Button>
		</div>
	);
};

export default ReportActionsCell;
